import { Link } from "react-router-dom";
import NewUserForm from "./NewUserForm";

export default function NewUser() {
  return (
    <div className="min-h-full px-4 sm:px-6 lg:px-8 py-6">
      {/* Page header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900">
            New User
          </h1>
          <p className="text-sm text-gray-500">
            Create a new account with roles and status.
          </p>
        </div>
        <Link
          to="/dash/users"
          className="rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
        >
          Back
        </Link>
      </div>

      {/* Form card */}
      <div className="mt-6">
        <NewUserForm />
      </div>
    </div>
  );
}
